import React from 'react'

const Poloshirts = () => {
  return (
    <div>Poloshirts</div>
  )
}

export default Poloshirts